//@flow
import React, { Component } from 'react';
import {
    Wrapper,
    Label,
    LabelSection,
    Error,
    Input,
    InputWrapper
} from './styledComponents';
import throttle from 'lodash/throttle';
import SVG from 'react-svg-inline';
import GoogleIcon from '../../images/google-g-logo.svg';

class TextField extends Component<Props, State> {

    static defaultProps = {
        label: '',
        type: 'text',
		placeholder: '',
        validations: [],
        attachSVG: false
    }

    constructor(props: Props){
        super(props);
        this.state = {
            value: props.value || '',
            isValid: true,
            isTouched: false,
            isBlurred: false,
            invalidMessage: ''
        };
    }

    componentDidMount(){
        const { innerRef } = this.props;
        typeof innerRef === 'function' && innerRef(this);
    }

    onBlur = () => this.setState(
        { isBlurred: true },
    () => {
        const { isTouched, isValid, value } = this.state;
        if (isTouched && isValid) {
            this.validateAndUpdate(value);
        }
    });

    onFocus = () => this.setState({ isTouched: true });

    onChange = (event: SyntheticEvent<HTMLInputElement>) => {
        const { value } = event.currentTarget;
        this.setState({
            value
        }, () => {
            this.validateAndUpdate(value);
        });
    }

    async validateAndUpdate(value: string, updateTouch?: boolean) {
        const {  validations } = this.props;
        let isValid = true;
        let invalidMessage = '';
        for (let i = 0; i < validations.length; i++) {
            if (validations[i].async === true) {
                const throttledValidation = throttle(validations[i].func, 666);
                isValid = await throttledValidation(value);
            } else {
                isValid = validations[i].func(value);
            }
            if (!isValid) {
                invalidMessage = validations[i].error;
                break;
            }
        }
        this.setState(state => {
            let changes = { isValid, invalidMessage };
            if (updateTouch)
                changes = { ...changes, isBlurred: true };
            return {
                ...state,
                ...changes
            };
        }, () => {
            const { onChange } = this.props;
            if (typeof onChange === 'function') {
                const { value, isValid, invalidMessage } = this.state;
                onChange(value, isValid, invalidMessage)
            }
        });
        return isValid;
    }

    render() {
        const { value, invalidMessage, isValid, isBlurred } = this.state;
        const { type, label, children, placeholder, attachSVG, style, LabelSectionStyle } = this.props;
        const shouldDisplayError = isBlurred && !isValid
        return (
            <Wrapper style={style}>
                <LabelSection>
                    <Label>{label}</Label>
                    {shouldDisplayError && <Error>{invalidMessage}</Error>}
                </LabelSection>
                <LabelSection style={LabelSectionStyle}>
                    {children}
                    <InputWrapper className={value && isValid ? "h-input-filled" : ""}>
                        {attachSVG && <SVG svg={GoogleIcon} height="20px" width="19px" className="h-google-logo" />}
                        <Input
                            type={type}
                            value={value}
                            onBlur={this.onBlur}
                            onChange={this.onChange}
                            onFocus={this.onFocus}
                            isValid={isValid}
                            isBlurred={isBlurred}
                            placeholder={placeholder}
                            width="328"
                        />
                    </InputWrapper>
                </LabelSection>
            </Wrapper>
        )
    }
}


//flow types for this component
type TextFieldType = "text" | "password"

type TextFieldValidation = {
    func: Function,
    error: string,
    async?: boolean
}

type Props = {
    label: string,
    type: TextFieldType,
    value: string,
    validations: Array<TextFieldValidation>,
    onChange: Function,
    innerRef?: Function,
    children?: any,
    placeholder: string,
    attachSVG: boolean
}

type State = {
    value: string,
    isValid: boolean,
    isBlurred: boolean,
    isTouched: boolean,
    invalidMessage: string
}


export default TextField
